import { Routes } from '@angular/router';
import { ReportListComponent } from './report-list/report-list.component';

export const routes: Routes = [
  // { path: '', redirectTo: '/report-list', pathMatch: 'full' },
  { path: '', component: ReportListComponent },
  { path: 'report-list', component: ReportListComponent },
];